import KeyframeLogoFull from "components/icons/keyframe-logo-full.svg";
import ParticleCircle from "components/animations/ParticleCircle";

const MobileDeviceMessageScreen = () => {
  return (
    <div className="mx-8 flex min-h-screen flex-col justify-center">
      <div className="flex flex-col items-center space-y-4 text-center">
        <div className="aspect-square w-[300px]">
          <ParticleCircle size="sm" />
        </div>
        <KeyframeLogoFull className="max-w-96 p-4" />
        <h2 className="text-sm text-secondary">
          is best experienced on desktop
        </h2>
        <section>
          <p className="text-sm text-neutral-500">
            Our app is optimized for larger displays. To experience all features
            Keyframe has to offer we recommend using tablet, laptop or desktop
            devices.
          </p>
        </section>
        <button
          className="p-2 text-xs text-disabled"
          onClick={() => {
            localStorage.setItem("kfMobileWarningDismissed", "true");
            window.dispatchEvent(new Event("mobileWarningDismissed"));
          }}
        >
          {"View Keyframe on mobile >"}
        </button>
      </div>
    </div>
  );
};

export default MobileDeviceMessageScreen;
